var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNafInsuranceArrowRightFromBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 35,
    viewBox: "0 0 42 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.75H15.2381V0H0V35H15.2381V31.25H3.80952V3.75H13.3333ZM40.0794 18.8281L41.4286 17.5L40.0794 16.1719L29.2857 5.54688L27.9365 4.21875L25.246 6.86719L26.5952 8.19531L34.1349 15.6172H12.6984V19.3672H34.1349L26.5952 26.7891L25.246 28.1172L27.9365 30.7656L29.2857 29.4375L40.0794 18.8125V18.8281Z",
    fill: "#3B6CCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNafInsuranceArrowRightFromBracket);
export default __webpack_public_path__ + "static/media/naf-insurance-arrow-right-from-bracket.303c0ca0d14ee520f84ccde3821ba71c.svg";
export { ForwardRef as ReactComponent };